<script setup lang="ts">
import type { ColumnFiltersState } from '@tanstack/vue-table'
import TableRowElemental from '../TableRowElemental/index.vue'
import TableRowElementalItem from '../TableRowElementalItem/index.vue'
import IconBox from '~~/src/components/DrawerSidebarRight/components/shared/IconBox.vue'
import ElemetalFolderIconPicker from '~~/src/components/Elemental/ElemetalFolderIconPicker/index.vue'
import type { Elemental, ElementalTypeEnum } from '~~/src/types/elemental'
import type { List } from '~~/src/types/list'
import {
  TableCell,
  TableRow,
} from '@/components/ui/table'

const props = defineProps<{
  elementalTypeId: ElementalTypeEnum
  list: Elemental | List
  columns: string[]
  label: string
  colspan: number
  dataIndex: number
  filters: ColumnFiltersState
}>()
</script>

<template>
  <TableRow
    class="block border-none"
  >
    <TableCell
      :colspan="props.colspan"
      class="block p-0 border-none"
    >
      <TableRowElemental
        v-if="list.isList"
        :elemental-type="list.elementalTypeId ?? 0"
        :list="list"
        :title="list.title"
        :cells-length="props.colspan"
        :elemental-label="props.label"
        :columns="props.columns"
        :filters="props.filters"
      >
        <template #list-icon>
          <IconBox class="h-7 w-7 flex-shrink-0 !p-0">
            <ElemetalFolderIconPicker :type="list.elementalTypeId ?? 0" />
          </IconBox>
        </template>
      </TableRowElemental>

      <TableRowElementalItem
        v-else
        :elemental="list"
        :data-index="dataIndex"
        :elemental-label="props.label"
        :folder-level="0"
        :columns="props.columns"
      />
    </TableCell>
  </TableRow>
</template>
